import SkillsTree from '../../features/skills-tree/SkillsTree';

export default function OrganizationPage() {
  return <SkillsTree />;
}

